import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";

import userService from "../services/user.service";

export const getFavoriteVideos = createAsyncThunk(
  "favoriteVideos/getFavoriteVideos",
  async (queryParams, thunkAPI) => {
    try {
      console.log("Query Params: ",queryParams);
      const response = await userService.getFavoriteVideos(queryParams);
      thunkAPI.dispatch(setMessage(response.data));
      return response.data.details;
    } catch (error) {
      thunkAPI.dispatch(setMessage(error.response));
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const setPage = createAsyncThunk(
  "favoriteVideos/setPage",
  async (page, thunkAPI) => {
      return page;
  }
);

const initialState = { videos: [], isFetching: true, page: 1 };

const favoriteVideosSlice = createSlice({
  name: "favoriteVideos",
  initialState,
  reducers: {
    removeFromFavorites:(state, action)=>{      
      state.videos=state.videos.filter(item => item.id !== action.payload.vid)
    }
  },
  extraReducers: {
    [getFavoriteVideos.fulfilled]: (state, action) => {
      const requestedPage = Number(action.meta.arg?.page ?? 1);

      state.isFetching = false;

      state.videos = requestedPage === 1 ? [...action.payload] : [...state.videos, ...action.payload];

      if(action.payload.length > 0){
        state.page = requestedPage + 1;
      }

    },
    [getFavoriteVideos.rejected]: (state, action) => {
      state.isFetching = false;
    },
    [setPage.fulfilled]: (state, action) => {
      state.page = action.payload;
    },
    [setPage.rejected]: (state, action) => {
    }
  },
});

export var { removeFromFavorites } = favoriteVideosSlice.actions;
const { reducer } = favoriteVideosSlice;
export default reducer;
